import { XMLHttpRequestLike } from "../Extensions";
import { ObjectHelper } from "../Helpers/ObjectHelper";
import { RadObject } from "../RadObject";
import { AjaxError } from "./AjaxError";
import { NAMESPACE } from "./_Namespace";

export class ServerErrorHelper extends RadObject
{
    public static override classNamespace = NAMESPACE + "ServerErrorHelper";
    public static override className = "ServerErrorHelper";

    public static processError(xhr: XMLHttpRequestLike)
    {
        let
            error = null,
            jsonError: string | undefined;

        try
        {
            if (xhr.responseType === "json")
                jsonError = xhr.response;
            else if (!xhr.responseType && typeof xhr.response === "string" && xhr.response)
                jsonError = ObjectHelper.fromJson(xhr.response);
        }
        catch (e) { /* Continue regardless of error */ }

        if (jsonError)
            error = AjaxError.fromObject(jsonError, xhr);

        if (error === null)
            error = AjaxError.fromErrorMessage(xhr.response, xhr);

        return error;
    }
}